/* eslint-disable */

/*
 * ⚠️ DO NOT EDIT ⚠️
 * This file is automatically generated, run "yarn run codegen"
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ScreenLayoutGetClubHouseQueryVariables = Exact<{
  clubhouseId?: number;
}>;

export type ScreenLayoutGetClubHouseQuery = {
  __typename: 'query_root';
  clubhouse_club_house_by_pk:
    | {
        __typename: 'clubhouse_club_house';
        id: number;
        club:
          | {
              __typename: 'clubs_club';
              id: number;
              color_primary: string | undefined;
              logo: string | undefined;
            }
          | undefined;
        tournament_logo:
          | Array<{
              __typename: 'clubhouse_screen';
              tournament:
                | {
                    __typename: 'tournaments_tournament';
                    id: number;
                    logo: string | undefined;
                  }
                | undefined;
              challenge:
                | {
                    __typename: 'tournaments_challenge';
                    tournament:
                      | {
                          __typename: 'tournaments_tournament';
                          id: number;
                          logo: string | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              phase:
                | {
                    __typename: 'tournaments_phase';
                    rule:
                      | {
                          __typename: 'tournaments_challenge_rule';
                          challenge:
                            | {
                                __typename: 'tournaments_challenge';
                                tournament:
                                  | {
                                      __typename: 'tournaments_tournament';
                                      id: number;
                                      logo: string | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export const ScreenLayoutGetClubHouseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScreenLayoutGetClubHouse' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clubhouseId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
          defaultValue: { kind: 'IntValue', value: '68' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clubhouse_club_house_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'clubhouseId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'club' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color_primary' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'tournament_logo' },
                  name: { kind: 'Name', value: 'screens' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_or' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_and' },
                                      value: {
                                        kind: 'ListValue',
                                        values: [
                                          {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'challenge_id',
                                                },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: {
                                                        kind: 'Name',
                                                        value: '_is_null',
                                                      },
                                                      value: {
                                                        kind: 'BooleanValue',
                                                        value: false,
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                          {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'challenge',
                                                },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'tournament',
                                                      },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'logo',
                                                            },
                                                            value: {
                                                              kind: 'ObjectValue',
                                                              fields: [
                                                                {
                                                                  kind: 'ObjectField',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      '_neq',
                                                                  },
                                                                  value: {
                                                                    kind: 'StringValue',
                                                                    value: '',
                                                                    block: false,
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_and' },
                                      value: {
                                        kind: 'ListValue',
                                        values: [
                                          {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'tournament_id',
                                                },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: {
                                                        kind: 'Name',
                                                        value: '_is_null',
                                                      },
                                                      value: {
                                                        kind: 'BooleanValue',
                                                        value: false,
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                          {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'tournament',
                                                },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'logo',
                                                      },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: {
                                                              kind: 'Name',
                                                              value: '_neq',
                                                            },
                                                            value: {
                                                              kind: 'StringValue',
                                                              value: '',
                                                              block: false,
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_and' },
                                      value: {
                                        kind: 'ListValue',
                                        values: [
                                          {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'phase_id',
                                                },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: {
                                                        kind: 'Name',
                                                        value: '_is_null',
                                                      },
                                                      value: {
                                                        kind: 'BooleanValue',
                                                        value: false,
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                          {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'phase',
                                                },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'rule',
                                                      },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'challenge',
                                                            },
                                                            value: {
                                                              kind: 'ObjectValue',
                                                              fields: [
                                                                {
                                                                  kind: 'ObjectField',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'tournament',
                                                                  },
                                                                  value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                      {
                                                                        kind: 'ObjectField',
                                                                        name: {
                                                                          kind: 'Name',
                                                                          value:
                                                                            'logo',
                                                                        },
                                                                        value: {
                                                                          kind: 'ObjectValue',
                                                                          fields:
                                                                            [
                                                                              {
                                                                                kind: 'ObjectField',
                                                                                name: {
                                                                                  kind: 'Name',
                                                                                  value:
                                                                                    '_neq',
                                                                                },
                                                                                value:
                                                                                  {
                                                                                    kind: 'StringValue',
                                                                                    value:
                                                                                      '',
                                                                                    block: false,
                                                                                  },
                                                                              },
                                                                            ],
                                                                        },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tournament' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'logo' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'challenge' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tournament' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'logo' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phase' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'challenge' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'tournament',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'logo',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScreenLayoutGetClubHouseQuery,
  ScreenLayoutGetClubHouseQueryVariables
>;
